import { Component, Inject, OnInit } from '@angular/core';
import { join, map as maap } from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { CommonComponent } from '@components/abstract/common-component.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Interview } from '@models/interviews/interview.model';
import { ModelService } from '@services/common/model.service';
import { Resident } from '@models/account/resident.model';

@Component({
  selector: 'app-transcriptions',
  templateUrl: './transcriptions.component.html',
  styleUrls: ['./transcriptions.component.scss'],
  providers: [
    {
      provide: 'InterviewsService',
      useFactory: () => new ModelService<Interview[]>(),
    },
  ],
})
export class TranscriptionsComponent extends CommonComponent implements OnInit {
  resident: Resident = this.route.snapshot.data.resident;
  interviews: Interview[] = [];

  visible = false;
  opened = false;
  constructor(
    private route: ActivatedRoute,
    private api: CommonVerbsApiService,
    @Inject('InterviewsService')
    public interviewsService: ModelService<Interview[]>
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.resident.interviews && this.resident.interviews.length) {
      this.visible = true;
      this.interviews = maap(this.resident.interviews, i => {
        if (i.transcriptions && i.transcriptions.length) {
          i.transcriptions = maap(i.transcriptions, t => {
            t.text = join(
              maap(t.content, c => `${c.word}`),
              ' '
            );
            return t;
          });
        }
        return i;
      });
    }
  }
}
